<template>
  <el-table
    :loading="declarationLoading"
    :disabled="declarationLoading"
    :data="properties"
    class="declaration__table"
    style="width: 100%">
    <el-table-column
      prop="name"
      :label="$t('declaration.tab.name')">
    </el-table-column>
    <el-table-column
      prop="quantity"
      :label="$t('declaration.tab.quantity')">
    </el-table-column>
    <el-table-column
      :formatter="formatingPrice"
      prop="price"
      :label="$t('declaration.tab.price')"
      width="180">
    </el-table-column>
    <el-table-column
      :formatter="formatingDate"
      prop="date"
      :label="$t('declaration.tab.date')"
      width="150">
    </el-table-column>
    <el-table-column
      :label="$t('declaration.tab.operations')"
      width="120">
    <template slot-scope="scope">
      <el-button
        size="mini"
        @click="editProperty(scope.row, scope.$index)">
          <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
        </el-button>
      <el-button
        size="mini"
        type="danger"
        @click="deleteProperty(scope.$index)">
        <font-awesome-icon :icon="['fas', 'trash']"/>
      </el-button>
    </template>
  </el-table-column>
  </el-table>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'declarationTab',
  props: {
    properties: {
      type: Array,
      default: () => [],
    },
    edited: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      declarationLoading: 'declarationStore/declarationLoading',
    }),
  },
  methods: {
    formatingDate({ date }) {
      const d = new Date(date);
      const day = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();
      const month = d.getMonth() + 1 < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    formatingPrice({ price }) {
      return this.$n(price, 'currency');
    },
    editProperty(property, index) {
      this.$emit('edit-property', property, index);
    },
    deleteProperty(index) {
      const properties = this.properties.slice(0);
      properties.splice(index, 1);
      this.$emit('update:properties', properties);
      this.$emit('update:edited', true);
    },
  },
};
</script>

<style lang="scss" scoped>

.declaration__table{
  margin-top: 10px;
}
:deep(tbody) {
  tr:first-child {
    .el-table_1_column_5 {
      @include breakpoint(wide) {
        border-top: 1px solid $--color-tab-border;
      }
    }
  }
  tr:last-child {
    .el-table_1_column_5 {
      @include breakpoint(wide) {
        border-bottom: 0;
      }
    }
  }
}
</style>
